import { RemoteRecordDataType } from 'b2b-apps/shop/common/redux/RemoteRecordData';
import { ComparedProduct } from 'b2b-common/core/product/api/ProductsCompare.types';
import {
  ADD_PRODUCT_TO_COMPARE,
  CLEAR_PRODUCTS_COMPARE,
  FETCH_PRODUCTS_COMPARE,
  FETCH_PRODUCTS_COMPARE_FULFILLED,
  FETCH_PRODUCTS_COMPARE_REJECTED,
  REMOVE_PRODUCT_FROM_COMPARE,
} from './actionTypes';

export type FetchProductsCompareAction = {
  type: typeof FETCH_PRODUCTS_COMPARE;
  payload: {
    skus: string[];
    category?: string;
  };
}

export type FetchProductsCompareRejectedAction = {
  type: typeof FETCH_PRODUCTS_COMPARE_REJECTED;
  payload: {
    error: ErrorType;
  };
}

export type FetchProductsCompareFulfilledAction = {
  type: typeof FETCH_PRODUCTS_COMPARE_FULFILLED;
  payload: {
    data: ComparedProduct[];
  };
}

export type AddProductToCompareAction = {
  type: typeof ADD_PRODUCT_TO_COMPARE;
  payload: {
    sku: string,
  }
}

export type RemoveProductFromCompareAction = {
  type: typeof REMOVE_PRODUCT_FROM_COMPARE;
  payload: {
    sku: string;
  }
}

export type ClearProductsCompareAction = {
  type: typeof CLEAR_PRODUCTS_COMPARE;
}

export type ProductsCompareState = RemoteRecordDataType<ComparedProduct>;

export type ProductsCompareActions =
  | FetchProductsCompareAction
  | FetchProductsCompareRejectedAction
  | FetchProductsCompareFulfilledAction
  | AddProductToCompareAction
  | RemoveProductFromCompareAction
  | ClearProductsCompareAction;

export type ComparisonBarProduct = {
  sku: string;
  name: string;
  cover: string;
}

export const COMPARE_PRODUCTS_COOKIE_NAME = 'compare_products';
